import React, { useCallback, useEffect, useRef } from 'react'

import Map from '../../../components/map/Map'
import PinWrapper from '../../../components/map/PinWrapper'
import { useGroupedMapPoints, useMapPoints } from './_load/MapPointsLoader'
import { useMapActions, useMapState } from '../../../components/map/MapContext'
import { debounce } from 'lodash'
import ClusterPinWrapper from '../../../components/map/ClusterPinWrapper'
import GroupedPinWrapper from '../../../components/map/GroupedPinWrapper'

const MapContent = () => {
  const mapPoints = useMapPoints()
  const groupedMapPoints = useGroupedMapPoints()
  const mapState = useMapState()
  const { setZoom, setBounds } = useMapActions()
  const mapInstance = useRef()
  const polyline = useRef()

  const doRequest = debounce(event => {
    mapState?.controller && mapState?.controller.abort()
    setZoom(event.zoom)
    setBounds(event.bounds)
  }, 1000)

  const onClick = useCallback(item => {
    const coordinateMin = new window.google.maps.LatLng(item.minLatitude, item.minLongitude)
    const coordinateMax = new window.google.maps.LatLng(item.maxLatitude, item.maxLongitude)

    const bounds = new window.google.maps.LatLngBounds()
    bounds.extend(coordinateMin)
    bounds.extend(coordinateMax)

    mapInstance.current.map_.fitBounds(bounds)
  }, [])

  useEffect(() => {
    if (!mapState.route?.length) {
      polyline?.current?.setMap(null)
      return
    }
    polyline?.current?.setMap(null)

    const maps = mapInstance.current.maps_
    const map = mapInstance.current.map_
    const linePath = mapState.route.map(item => {
      return { lat: item.latitude, lng: item.longitude }
    })

    const line = new maps.Polyline({
      path: linePath,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    })

    line.setMap(map)

    const bounds = new maps.LatLngBounds()

    line.getPath().forEach(latLng => {
      bounds.extend(latLng)
    })
    map.fitBounds(bounds)

    polyline.current = line
  }, [mapState.route])

  return (
    <Map
      ref={mapInstance}
      height="100vh"
      defaultCenter={{ lat: -19.6341, lng: -43.9654 }}
      noLock
      defaultZoom={2}
      enableStreetView
      disableFullScreen
      _yesIWantToUseGoogleMapApiInternals
      onChange={event => doRequest(event)}
      route={mapState.route}
    >
      {!!mapPoints &&
        mapPoints?.map(item => {
          if (item.total > 1) {
            return (
              <ClusterPinWrapper
                key={`${item.clusterId}_${item.recordId}`}
                item={item}
                onClick={() => onClick(item)}
                lat={item.latitude}
                lng={item.longitude}
              />
            )
          }
          return false
        })}

      {!!groupedMapPoints &&
        Object.keys(groupedMapPoints)?.map(key => {
          const items = groupedMapPoints[key]

          if (items.length > 1) {
            return <GroupedPinWrapper items={items} key={key} lat={items[0].latitude} lng={items[0].longitude} />
          } else {
            return (
              <PinWrapper item={items[0]} key={items[0].recordId} lat={items[0].latitude} lng={items[0].longitude} />
            )
          }
        })}
    </Map>
  )
}

export default MapContent
